import { render, staticRenderFns } from "./FrameNav.vue?vue&type=template&id=37439370&"
import script from "./FrameNav.vue?vue&type=script&lang=js&"
export * from "./FrameNav.vue?vue&type=script&lang=js&"
import style0 from "./FrameNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports